import useTranslation from "@babackapp/translations/use-translation";
import { TabsList, TabsTrigger } from "@babackapp/ui/components/tabs";
import { useFormContext } from "react-hook-form";
import { ShopImportFormValues } from "./import-settings-form-types";

export default function ImportFormTabs() {
  const {
    formState: { errors },
    trigger,
  } = useFormContext<ShopImportFormValues>();

  const t = useTranslation();

  return (
    <TabsList onChange={() => trigger()} className="grid grid-cols-3 mb-8">
      <TabsTrigger
        value="server"
        className={errors.server ? "text-red-500" : ""}
      >
        {t("settings.integrations.imports.tabs.server")}
      </TabsTrigger>

      <TabsTrigger
        value="options"
        className={errors.options ? "text-red-500" : ""}
      >
        {t("settings.integrations.imports.tabs.options")}
      </TabsTrigger>

      <TabsTrigger
        value="mapping"
        className={errors.mapping ? "text-red-500" : ""}
      >
        {t("misc.mapping")}
      </TabsTrigger>
    </TabsList>
  );
}
